import {Box, Grid} from '@mui/material';

interface Props {
  currentIndex: number;
  total: number;
  onClick: (index: number) => void;
  activeColor: string;
  buttonColor: string;
}
export const CarouselIndexCounter = ({currentIndex, total, onClick, activeColor, buttonColor}: Props) => {
  const buttonCount = Array.from(Array(total));
  const isActive = (idx: number) => idx === currentIndex;
  const transformStyle = {
    transform: 'scale(1.30)',
    transition: 'transform 0.1s ease-in-out',
    transformOrigin: 'center',
    cursor: 'pointer',
  };

  return (
    <Grid width='auto' display='flex' flexDirection='column' justifyContent='center'>
      <Grid width='auto' display='flex' height='8px' justifyContent='flex-start' gap='8px'>
        {buttonCount.map((_, idx) => {
          // Filtering out buttons of the dummy slides
          if (idx === 0 || idx === total - 1) {
            return null;
          }
          return (
            <Box
              key={`counter-${idx}`}
              onClick={() => onClick(idx)}
              sx={{
                minWidth: '8px',
                maxHeight: '8px',
                borderRadius: '50%',
                backgroundColor: isActive(idx) ? activeColor : buttonColor,
                ...(isActive(idx) && {...transformStyle}),
                '&:hover': {...(!isActive(idx) && {...transformStyle})},
              }}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};
